var cities = [
    { 'code': '410000', 'city': '河南省' },
    { 'code': '410400', 'city': '平顶山市' },
    { 'code': '410401', 'city': '市本级' },
    { 'code': '410402', 'city': '新华区' },
    { 'code': '410403', 'city': '卫东区' },
    { 'code': '410404', 'city': '石龙区' },
    { 'code': '410411', 'city': '湛河区' },
    { 'code': '410421', 'city': '宝丰县' },
    { 'code': '410422', 'city': '叶县' },
    { 'code': '410423', 'city': '鲁山县' },
    { 'code': '410425', 'city': '郏县' },
    { 'code': '410481', 'city': '舞钢市' },
    { 'code': '410482', 'city': '汝州市' },
    { 'code': '410471', 'city': '高新区' },
    { 'code': '410472', 'city': '示范区' }
]

export default cities
